import React, { useState,useRef, useEffect } from 'react'
import Header from '@/components/Header'
import TimeBlock from './components/TimeBlock'
import { Content } from './style'
import Reward from './components/reward';
import Rank from './components/rank';
import Explain from './components/explain';
import Invite from './components/invite';
import Combination from './components/combination.js';

import bridge from '@/config/JSbridge'
import smoothscroll from 'smoothscroll-polyfill';
import  bwmodel from '@/config/bwmodel'
import { connect } from 'react-redux';
import OpenApp from '../../components/OpenApp';
import DescIcon from './../activity_80/components/DescIcon'


import './style.css'
import { getActivityUserInfo } from '@/api/user-new'

import moment from 'moment'

import Footer from './Footer/index';

const Member = ({token}) => {
  const active_id = 100;
  const [ userInfo, setUserInfo ] = useState({})
  const [ isLogin, setIsLogin ] = useState(true)
  const [ endTime, setEndTime ] = useState(null)
  const [ startTime, setStartTime] = useState(null)
  const [ status, setStatus ] = useState('t1')
  const [rankIndex, setRankIndex] = useState(0);
  const shareUrl = `#/active_${active_id}/share-pull-regist/`
  const childRef = useRef();
   const isStorm = bwmodel.app === 'storm';

  console.log(isLogin);
  smoothscroll.polyfill();

  useEffect(async() => {
    // document.body.style = "background-color:#F03100B!important;"
    document.body.style = "background-color:#F0395B!important;"
    getData()

    // setShareLinkParams()

    
  }, []);

  useEffect(()=> {
   
    bridge.addRegisterHandler([
    {
      name: 'viewWillAppear',
      callback: (res) => {
        // getList()
        if (childRef.current) {
          childRef.current.refresh();
        }
    
      }
    },
  ])
    
  },[])
  


  const setShareLink = (userInfo = {user:{}}) => {

    bridge.callHandler('nativeEvent', {
      event: 'shareLink',
      params: {
        // shareLinkParams:{
        title: `${userInfo.user && userInfo.user.nickname ? userInfo.user.nickname :''}邀请您来参与组合炒股大赛，赢取万元大奖！`,
        desc: '华为P70、风云新款周边、1000元京东卡…..13次赢取大奖机会！',
        thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
        linkUrl: process.env.REACT_APP_DEMAND_URL + shareUrl + userInfo.code,
        // }
      }
    })
  }
  
  let getData = () => {
    getActivityUserInfo(active_id).then(res => {
      let info = {
        num: res.invitedQuantity || 0,
        percent: res.ranking || 0,
        timeOver: res.activityState === 2,
        // myName: res.user.nickname,
        points: res.points,
        code: res.invitationCode,
        user: res.user || {}
      }
     
      let eTime = moment(res.endTime).format('YYYY年MM月DD日')
      let sTime = moment(res.startTime).format('YYYY年MM月DD日')
      setStartTime(sTime)
      setEndTime(eTime)

      setUserInfo(info)
      
      // 重新设置分享信息
      // setShareLinkParams(info)

      
      if(!res.user) {
        setIsLogin(false);
        // Toast.info('请先登录')
      }
      // setOverTime(parseInt(endTime.diff(startTime) / 1000, 10))
    }).catch((error) => {

      let res = error.response
      if (res && res.status === 401) {
        setIsLogin(false);
        
        // Toast.info('请先登录')
      }
    })
  }
 
  const tabs = [
    {
      key: 't1',
      value: '大赛奖励'
    },
    {
      key: 't2',
      value: '大赛排行'
    },
    {
      key: 't3',
      value: '我的邀请'
    }
  ]
  const changeTab =(key) => {
    setStatus(key)
  }

  const getRank = () => {
  
    const num = rankIndex + 1;
    setRankIndex(num)

  }
  return (
    <div>
      <Header 
        title={'炒股大赛，赢取万元大奖'} 
        right={
            bwmodel.compareVersion('4.17.9') ?( <img 
            onClick={()=> {
              setShareLink(userInfo)
            }} 
            style={{width:'20px','vertical-align': 'middle'}} 
            src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} 
            alt="分享" 
          />
            )
        :''
          
        }
      />
      <Content >
        <img className="member-img" src={require('@/img/activity_100/img1@2x.png')} alt="市值风云" />
        <TimeBlock startTime={startTime} endTime={endTime}/>
       
        <div className={ status === 't1' ? 'show':'hidden'}>
        
          <Combination ref={childRef}  token={token} user={userInfo.user} getRank={()=> {getRank()}}/>
        
          <div className="title-box2">
            <div className="title">季赛奖励：万元大奖等你来拿</div>
          </div>
          
          <img className="member-img" style={{marginTop: '0px',padding: '0 3vw',boxSizing:'border-box'}}src={require('@/img/activity_100/1@2x.png')} alt="市值风云" />
          <div className="title-box2">
              <div className="title">周赛奖励：12周比赛，周周拿奖</div>
            </div>
          <img className="member-img"  style={{marginTop: '0px',padding: '0 3vw',boxSizing:'border-box'}} src={require('@/img/activity_100/2@2x.png')} alt="市值风云" />
   
            <div className="title-box2">
              <div className="title">邀请好友奖励，朋友带你拿万元大奖</div>
            </div>
           
          <img className="member-img"  style={{marginTop: '0px',padding:'0 3vw',boxSizing:'border-box'}} src={require('@/img/activity_100/3@2x.png')} alt="市值风云" />
         
           
            <img className="member-img"  style={{marginTop: '30px',padding:'0 3vw 0vw',boxSizing:'border-box'}}  src={require('@/img/activity_100/invite.png')} alt="市值风云" />
      
          <Footer userInfo={userInfo} ></Footer>
       
        </div>

        
        <div className={ status === 't2' ? 'show':'hidden'}>
          <Rank  rankIndex={rankIndex}  activityId = {active_id } token={token}/>
        </div>
      

         <div className={ status === 't3' ? 'show':'hidden'}>
          <Invite activityId = {active_id} token={token}/>
          
          <Footer userInfo={userInfo} ></Footer>        
        </div>


        <div className='contentfooter footer'>
          <div className='flex'>
            {
              tabs.map(it => {
                return( <div
                   key={it.key} 
                   className={  it.key === status? 'flex-item block':'flex-item'  } 
                    onClick={()=> {
                      changeTab(it.key)
                      
                    }}
                >{it.value}</div>
                )
              })
            }
          </div>
        </div>
      </Content>
      
    
      {/* 我的奖励 */}
      <Reward activityId = {active_id} token={token}></Reward>

      {/* 活动说明 */}
      <Explain />

       {
        !isStorm && 
        <div>
          <OpenApp bottom='bottom'></OpenApp>
        </div>
       }
        <DescIcon  top='19vw'/>
    </div>
  );
}


const mapStateToProps = (state) => ({
  token: state.user.accessToken || '', 
});

export default React.memo(connect(mapStateToProps)(Member))




// WEBPACK FOOTER //
// ./src/views/activity_100/index.js